import React from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import useScrollToTop from "../../../../hooks/useScrollToTop";

import useTeamManager from "./hooks/useTeamManager";

import TeamStats from "./components/TeamStats";
import TeamToolbar from "./components/TeamToolbar";
import TeamTable from "./components/TeamTable";
import TeamMemberFormDrawer from "./components/TeamMemberFormDrawer";

export default function TeamClub() {
  useScrollToTop();

  const {
    loading,
    saving,
    stats,
    query,
    functionFilter,
    functionOptions,
    visibleTeamMembers,
    filteredTeamMembers,
    visibleCount,
    drawer,
    demoMode,

    setQuery,
    setFunctionFilter,
    resetFilters,
    loadMore,
    refreshData,

    openCreateDrawer,
    openEditDrawer,
    closeDrawer,
    handleCreateMember,
    handleUpdateMember,
    handleDeleteMember,
  } = useTeamManager();

  return (
    <section className="w-full pb-10 font-satoshi">
      <div className="mx-auto max-w-[1400px] space-y-5">
        <TeamToolbar
          query={query}
          functionFilter={functionFilter}
          functionOptions={functionOptions}
          loading={loading}
          demoMode={demoMode}
          onQueryChange={setQuery}
          onFunctionChange={setFunctionFilter}
          onReset={resetFilters}
          onRefresh={refreshData}
          onCreate={openCreateDrawer}
        />

        <TeamStats stats={stats} />

        <TeamTable
          members={visibleTeamMembers}
          loading={loading}
          totalRows={filteredTeamMembers.length}
          visibleCount={visibleCount}
          demoMode={demoMode}
          onLoadMore={loadMore}
          onEdit={openEditDrawer}
          onDelete={handleDeleteMember}
        />
      </div>

      <TeamMemberFormDrawer
        isOpen={drawer.type === "create"}
        mode="create"
        saving={saving}
        onClose={closeDrawer}
        onCreate={handleCreateMember}
      />

      <TeamMemberFormDrawer
        isOpen={drawer.type === "edit"}
        mode="edit"
        member={drawer.member}
        saving={saving}
        onClose={closeDrawer}
        onUpdate={handleUpdateMember}
      />

      <ToastContainer position="top-right" autoClose={2500} theme="colored" />
    </section>
  );
}